import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ProfileContext } from "../../context/ProfileContext";
import AddBeneficiaryForm from "./AddBeneficiaryForm";

const BeneficiariesManagement = () => {
  const { beneficiaries, removeBeneficiary } = useContext(ProfileContext);
  const { t } = useTranslation();

  return (
    <div className="p-6 bg-white rounded-2xl border border-[#e8e3d8]">
      <h2 className="text-xl md:text-2xl font-light text-gray-900 mb-4" style={{ fontFamily: "Georgia, serif" }}>
        {t("beneficiaries.title")}
      </h2>

      {beneficiaries.length === 0 ? (
        <p className="text-sm text-gray-500 mb-4">
          {t("beneficiaries.empty")}
        </p>
      ) : (
        <ul className="space-y-2 mb-4">
          {beneficiaries.map((beneficiary) => (
            <li
              key={beneficiary.id}
              className="flex justify-between items-center"
            >
              <span>
                {beneficiary.name} ({beneficiary.relation})
              </span>
              <button
                className="text-red-500 hover:text-red-700 text-sm"
                onClick={() => removeBeneficiary(beneficiary.id)}
              >
                {t("beneficiaries.remove")}
              </button>
            </li>
          ))}
        </ul>
      )}

      <AddBeneficiaryForm />
    </div>
  );
};

export default BeneficiariesManagement;
